namespace $.$$ {

	/** Публичный ключ участника. Ленды диалога шифрованные, и право читать их
	 * заворачивается на ключ конкретного человека — по одному лишь его
	 * идентификатору выдать это право нечем. Идентификатор — хеш ключа,
	 * поэтому чужой ключ, подложенный под чужую же запись, отличается от
	 * настоящего пересчётом на месте, без всякой сети. */
	export class $bog_gram_key extends $giper_baza_dict.with({
		Pass: $giper_baza_atom_text,
	}) {}

}
